<template>
    <div class="container">
        <div class="col-1 align-self-center">
            <arrow
                direction="left"
                :route="'/introduction'"
                :routeName="description2"
            ></arrow>
        </div>
        <article>
            <section :class="animation">
                <h2>Qbility Web-Tool</h2>
                <div class="input-fields">
                    <div
                        class="input-container"
                        v-for="(field, index) in formSteps[activeStep].fields"
                        :key="'field' + index"
                    >
                        <label class="input-label">{{ field.label }}</label>
                        <input
                            type="text"
                            :class="{ 'wrong*-input': !field.valid }"
                            v-model="field.value"
                            required
                        />
                    </div>
                </div>
                <div>
                    <div class="actions">
                        <button
                            v-if="
                                activeStep === formSteps.length - 1 ||
                                    test == false
                            "
                            @click="checkFields"
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </section>
        </article>
        <div v-if="test == true" class="col-1 align-self-center">
            <arrow
                direction="right"
                :route="'/question'"
                :routeName="description1"
            ></arrow>
        </div>
    </div>
</template>

<script>
import Arrow from "../js/components/Arrow.vue";
export default {
    components: {
        Arrow
    },

    data: () => {
        return {
            description1: "Next",
            description2: "Back",
            test: false,
            activeStep: 0,
            animation: "animate-in",
            formSteps: [
                {
                    title: "Questionary Title",
                    header:
                        "Bitte beantworten Sie vorab ein paar Fragen zu Ihrem Unternehmen:",
                    fields: [
                        {
                            label: "Unternehmenssitz",
                            value: "",
                            valid: true,
                            pattern: /.+/
                        },
                        {
                            label: "Unternehmensgröße (Umsatz)​",
                            value: "",
                            valid: true,
                            pattern: /.+/
                        },
                        {
                            label: "Unternehmensgröße (Mitarbeiter)​",
                            value: "",
                            valid: true,
                            pattern: /.+/
                        }
                    ]
                }
            ]
        };
    },
    methods: {
        submitStep() {
            this.test = true;
        },
        checkFields() {
            let valid = true;
            this.formSteps[this.activeStep].fields.forEach(field => {
                if (!field.pattern.test(field.value)) {
                    valid = false;
                    field.valid = false;
                } else {
                    field.valid = true;
                }
            });
            if (valid) {
                this.submitStep();
            } else {
                this.animation = "animate-wrong";
                setTimeout(() => {
                    this.animation = "";
                }, 400);
                alert("Please Fill all the fields corectly !");
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Noto+Sans&display=swap");
@mixin flexbox() {
    display: flex;
    justify-content: center;
    align-items: center;
}
.container {
    @include flexbox();
    width: 100%;
    min-height: 100vh;
    font-family: "Noto Sans", sans-serif;
}
article {
    display: flex;
    margin: 10px;
    width: calc(100% - 20px);
    max-width: 720px;
    min-height: 480px;

    section {
        @include flexbox();
        flex-direction: column;
        width: 100%;
        background-color: #fff;
        box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2),
            0 10px 10px rgba(0, 0, 0, 0.2);
        h2 {
            font-size: 2rem;
            color: #179c7d;
            margin: 0;
            padding: 20px;
        }
        .input-fields {
            @include flexbox();
            flex-direction: column;
            width: 100%;
        }
        .input-container {
            position: relative;
            padding: 20px 20px 20px 20px;
            width: calc(100% - 40px);
            max-width: 400px;
            input {
                position: relative;
                width: 100%;
                font-family: "Noto Sans", sans-serif;
                font-size: 0.8rem;
                color: #555;
                outline: none;
                border: none;
                border-bottom: 1px inset #179c7d;
                &:valid + .input-Label {
                    top: 10px;
                    left: 20px;
                    font-size: 0.7rem;
                    font-weight: normal;
                    color: #999;
                }
                &.wrong-input + .input-label {
                    color: #b92938;
                }
            }
        }
        .input-label {
            left: 20px;
            font-size: 1rem;
            color: rgb(0, 0, 0);
            pointer-events: none;
        }
        .actions {
            margin: 0;
            button {
                font-family: "noto Sans", sans-serif;
                outline: none;
                border: none;
                color: #fff;
                background-color: #179c7d;
                font-size: 1.35rem;
                padding: 5px 20px;
                margin: 40px;
                text-transform: uppercase;
                border-radius: 3px;
                cursor: pointer;
            }
        }
    }
}

.animate-wrong {
    animation: wrong 0.6s ease-in-out;
}
@keyframes in {
    0% {
        opacity: 0;
        transform: rotateY(0deg);
    }
    100% {
        opacity: 1;
        transform: rotateY(0deg);
    }
}
@keyframes wrong {
    0% {
        transform: translateX(0);
    }
    20% {
        transform: translateX(30px);
    }
    40% {
        transform: translateX(10px);
    }
    60% {
        transform: translateX(30px);
    }
    80% {
        transform: translateX(10px);
    }
    100% {
        transform: translateX(0);
    }
}
</style>
